import Block from './Block'
import TwitterFeed from '../util/TwitterFeed'
import App from '../App'

export default class Twitter extends Block {

  bindMethods() {
    super.bindMethods()
    
    this.onTweeterReady = this.onTweeterReady.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  onEnterCompleted() {
    this.items = []
    this.twitterFeed = new TwitterFeed()
    this.twitterFeed.getDatas().then(this.onTweeterReady)
  }

  onTweeterReady(data) {
    for (let i = 0; i < data.length; i++) {
      const tweetWrapper = document.createElement('a')
      const dateDOM = document.createElement('div')
      const textDOM = document.createElement('div')

      tweetWrapper.classList.add('tweet')
      tweetWrapper.dataset.scroll = true
      dateDOM.classList.add('tweet__date')
      textDOM.classList.add('tweet__text')

      tweetWrapper.href = data[i].url
      tweetWrapper.target = '_blank'
      tweetWrapper.rel = 'nooepener'

      const date = new Date(data[i].date)
      const dateFrom = Math.round((Date.now() - date) / 86400000)
      
      dateDOM.textContent = dateFrom + ' day ago'
      textDOM.textContent = data[i].content

      tweetWrapper.appendChild(dateDOM)
      tweetWrapper.appendChild(textDOM)

      tweetWrapper.addEventListener('mouseenter', this.onMouseEnter)
      tweetWrapper.addEventListener('mouseleave', this.onMouseLeave)

      this.items.push(tweetWrapper)

      this.el.appendChild(tweetWrapper)
    }
 
    setTimeout(() => {
      App.smoothScroll.update()
      App.background.updateSectionsPosition()
    }, 500)
  }

  onMouseEnter() {
    App.cursor.scaleTo(100)
  }

  onMouseLeave() {
    App.cursor.resetScale()
  }

  destroy() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].removeEventListener('mouseenter', this.onMouseEnter)
      this.items[i].removeEventListener('mouseleave', this.onMouseLeave)
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Twitter.js